import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import 'moment/locale/pt-br';

moment.locale('pt-br');

@Pipe({
  name: 'fromnow',
  standalone: false
})
export class DateFromNowPipe implements PipeTransform {
  transform(timestamp: number | Date | string): string {
    if (typeof timestamp === 'string' || timestamp instanceof Date) {
      return moment.utc(timestamp).local().fromNow();
    }
    return moment.utc(timestamp * 1000).local().fromNow();
  }
}

@Pipe({ name: 'fromnowlimited', standalone: true, pure: false })
export class DateFromNowLimitedPipe implements PipeTransform {
  transform(timestamp: number | string | Date): string {
    const now = moment().local();

    if (typeof timestamp === 'string' || timestamp instanceof Date) {
      const time = moment.utc(timestamp).local();
      if (now.diff(time, 'days') <= 2) {
        return time.local().fromNow();
      } else {
        return time.local().format('DD/MM - HH:mm');
      }
    }
    

    const time = moment(timestamp * 1000);
    if (now.diff(time, 'days') <= 2) {
      return time.fromNow();
    } else {
      return time.format('DD/MM - HH:mm');
    }
  }
}

@Pipe({ name: 'datetimeshort', standalone: true })
export class DateTimeShortPipe implements PipeTransform {
  transform(timestamp: number | string | Date): string {
    const date = typeof timestamp === 'string' || timestamp instanceof Date
      ? moment.utc(timestamp).local()
      : moment(timestamp * 1000);

    // Verifica se a data é hoje
    if (date.isSame(moment(), 'day')) {
      return date.format('HH:mm');
    } else {
      return date.format('DD/MM');
    }
  }
}

@Pipe({ name: 'datetime', standalone: true })
export class DateTimePipe implements PipeTransform {
  transform(timestamp: number | string | Date): string {
    if (typeof timestamp === 'string' || timestamp instanceof Date) {
      return moment.utc(timestamp).local().format('DD/MM/YYYY HH:mm');
    }

    return moment(timestamp * 1000).format('DD/MM/YYYY HH:mm');
  }
}

@Pipe({ name: 'date', standalone: true })
export class DatePipe implements PipeTransform {
  transform(timestamp: number | string | Date): string {
    if (typeof timestamp === 'string' || timestamp instanceof Date) {
      return moment.utc(timestamp).local().format('DD/MM/YYYY');
    }

    return moment(timestamp * 1000).format('DD/MM/YYYY');
  }
}

@Pipe({ name: 'time', standalone: true })
export class TimePipe implements PipeTransform {
  transform(timestamp: number | string | Date): string {
    if (typeof timestamp === 'string' || timestamp instanceof Date) {
      return moment.utc(timestamp).local().format('HH:mm');
    }

    return moment(timestamp * 1000).format('HH:mm');
  }
}

@Pipe({ name: 'datefromnowlimited', standalone: true })
export class DateFromNowLimitedHeaderPipe implements PipeTransform {
  transform(value: number | string | Date | null | undefined): string {
    if (value === null || value === undefined) {
      return 'Data indisponível';
    }

    const date = typeof value === 'string'
      ? moment(value)
      : value instanceof Date
        ? moment(value)
        : typeof value === 'number'
          ? moment(value)
          : moment(value);

    if (!date.isValid()) {
      return 'Data indisponível';
    }

    const localDate = date.clone().local();
    const startOfDay = localDate.clone().startOf('day');
    const today = moment().local().startOf('day');
    const diffDays = today.diff(startOfDay, 'days');

    if (diffDays === 0) {
      return 'Hoje';
    }

    if (diffDays === 1) {
      return 'Ontem';
    }

    if (diffDays >= 0 && diffDays <= 5) {
      return this._formatWeekday(localDate);
    }

    if (diffDays < 0 && Math.abs(diffDays) <= 5) {
      return this._formatWeekday(localDate);
    }

    return startOfDay.format('DD/MM/YYYY');
  }

  private _formatWeekday(date: moment.Moment): string {
    const weekday = date.format('dddd');
    return weekday.charAt(0).toUpperCase() + weekday.slice(1);
  }
}

@Pipe({ name: 'duration', standalone: true })
export class DurationPipe implements PipeTransform {
  transform(duration: number): string {
    return moment.duration(duration, 'seconds').humanize();
  }
}
